import { useAtomValue } from 'jotai';
import { dashboardUrlParamsAtom } from 'src/atoms/filters/dashboard';
import { Routes } from 'src/Routes.constants';

export const useDashboardUrlFromFilters = () => {
  const searchParams = useAtomValue(dashboardUrlParamsAtom);
  return `${Routes.dashboard}?${searchParams.toString()}`;
};
